import { create } from 'zustand';

/**
 * Hands a draft to a customer's composer without sending it (tv-isee): a
 * "Try again" / "Send as agent instead" on a failed message, or "Use reply"
 * on a suggestion outside 24h. The human still presses send — required for
 * human-agent sends.
 */
interface ComposerDraftState {
  draft: { customerId: string; body: string; templateId?: string; depositId?: string; nonce: number } | null;
  /** `depositId` ties the draft to the deposit it belongs to (tv-isee); optional, always last. */
  setDraft: (customerId: string, body: string, templateId?: string, depositId?: string) => void;
  clear: () => void;
}

export const useComposerDraftStore = create<ComposerDraftState>((set) => ({
  draft: null,
  setDraft: (customerId, body, templateId, depositId) =>
    set({ draft: { customerId, body, templateId, depositId, nonce: Date.now() } }),
  clear: () => set({ draft: null }),
}));
